export function Table({ className = "", children, ...props }) {
  return (
    <div className="relative w-full overflow-auto">
      <table className={`w-full caption-bottom text-sm ${className}`} {...props}>
        {children}
      </table>
    </div>
  )
}

export function TableHeader({ className = "", children, ...props }) {
  return (
    <thead className={`border-b border-border bg-muted/50 ${className}`} {...props}>
      {children}
    </thead>
  )
}

export function TableBody({ className = "", children, ...props }) {
  return (
    <tbody className={`${className}`} {...props}>
      {children}
    </tbody>
  )
}

export function TableRow({ className = "", children, ...props }) {
  return (
    <tr
      className={`border-b border-border transition-colors hover:bg-muted/50 ${className}`}
      {...props}
    >
      {children}
    </tr>
  )
}

export function TableHead({ className = "", children, ...props }) {
  return (
    <th
      className={`h-12 px-4 text-left align-middle text-sm font-semibold text-foreground ${className}`}
      {...props}
    >
      {children}
    </th>
  )
}

export function TableCell({ className = "", children, ...props }) {
  return (
    <td className={`p-4 align-middle text-foreground ${className}`} {...props}>
      {children}
    </td>
  )
}
